module.exports = __webpack_public_path__ + "img/fullscreen.7d92be4c.png";